module.exports = __webpack_public_path__ + "static/media/loff.69004660.mp3";